import { render, staticRenderFns } from "./MyTrade.vue?vue&type=template&id=515256c8&scoped=true"
import script from "./MyTrade.vue?vue&type=script&lang=js"
export * from "./MyTrade.vue?vue&type=script&lang=js"
import style0 from "./MyTrade.vue?vue&type=style&index=0&id=515256c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515256c8",
  null
  
)

export default component.exports